import React, { useState, useCallback, Fragment } from "react";
import { Link } from "gatsby";

import { Menu, MenuItem, IconButton } from "@mui/material";

import _ from "lodash";

import { getTranslatedEntityLink } from "../../util"

const LanguageSelector = ({ locales, pageContext, entity, ...props}) => {
    const { defaultLocale, locale: selectedLocale } = pageContext || {};

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    },[setAnchorEl]);

    return <>{locales?.length > 1 && <>
        <IconButton
            edge="end"
            color="inherit"
            aria-label="language"
            onClick={handleMenu}
            size="large">
            {selectedLocale.split('-').shift()}
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} getContentAnchorEl={null} keepMounted style={{zIndex: 65535 }}
              anchorOrigin={{ vertical: "bottom", horizontal: "left", }} >

            { locales.map( l => {
                const link = getTranslatedEntityLink({ locale: l, defaultLocale, entity});

                return <MenuItem key={l.code} onClick={handleClose} component={Link} to={link}>{l.name}</MenuItem>
            })}        
        </Menu>
    </>}</>;
};

export default LanguageSelector;

